export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offer ID"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker ID"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter ID Code"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter Maker ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示我的报价"])}
}